
import Vue from "vue";
import YmapPlugin, {
  loadYmap
} from "vue-yandex-maps";

const settings = {
  apiKey: process.env.yandexApiKey,
  lang: "ru_RU",
  coordorder: "latlong",
  version: "2.1",
}
Vue.use(YmapPlugin, settings);

export default {
  name: "YandexMap",

  data: function () {
    return {
      yandexMapCoords: [57.649562, 82.957988],

      yandexMap: null
    }
  },

  props: {
    cityFrom: "",
    cityTo: "",
  },

  watch: {
    cityFrom: async function () {
      await this.yandexMap?.geoObjects?.removeAll();
      await this.setCitiesForMap();
    },
    cityTo: async function () {
      await this.yandexMap?.geoObjects?.removeAll();
      await this.setCitiesForMap();
    },
  },

  mounted: async function () {
    await this.initYandexMap();
  },

  methods: {
    initYandexMap: async function () {
      if (!this.$refs.yandexMap) {
        return
      }

      await loadYmap({...settings, debug: true});
      this.yandexMap = new ymaps.Map(this.$refs.yandexMap, {
        center: this.yandexMapCoords,
        zoom: 4,
        behaviors: ['drag', 'dblClickZoom', 'multiTouch']
      });

      await this.setCitiesForMap();
    },
    setCitiesForMap: async function () {
      if (!this.cityFrom || !this.cityTo) {
        return
      }

      let cityFrom, cityTo = null;
      if (this.cityFrom) {
        cityFrom = await this._getInformationCity(this.cityFrom);
      }
      if (this.cityTo) {
        cityTo = await this._getInformationCity(this.cityTo);
      }

      await this.yandexMap?.geoObjects?.removeAll();

      const yandexMap = this.yandexMap;
      const cluster = this._generateCluster();

      if (cityFrom && cityFrom.length === 2) {
        const placemark = this._generatePlacemark({
          coordinates: cityFrom,
          label: "A"
        });
        cluster.add(placemark);
      }
      if (cityTo && cityTo.length === 2) {
        const placemark = this._generatePlacemark({
          coordinates: cityTo,
          label: "B"
        });
        cluster.add(placemark);
      }

      yandexMap.geoObjects.add(cluster);
      yandexMap.setBounds(cluster.getBounds(), {
        delay: 0,
        checkZoomRange: false,
        zoomMargin: [20, 0]
      });

      if (cityFrom && cityFrom.length === 2 && cityTo && cityTo.length === 2) {
        await this.getCitiesDistance();
      }
    },
    getCitiesDistance: async function () {
      ymaps.route([this.cityFrom, this.cityTo], {
        multiRoute: true
      }).done(function (route) {
        const activeRoute = route.getActiveRoute();
        const distance = activeRoute.properties.get("distance").text;
        this.$emit("changeDistance", distance);

        route.options.set({
          strokeColor: 'bb460d',
          opacity: 1
        });
        route.options.set("mapStateAutoApply", true);
        this.yandexMap.geoObjects.add(route);
      }, function (err) {
        throw err;
      }, this);
    },


    _getInformationCity: async function (city) {
      const coordinates = await ymaps.geocode(city).then((res) => {
        return res.geoObjects.get(0).geometry.getCoordinates()
      }).catch(() => {
        return []
      });
      return coordinates
    },
    _generateCluster: function () {
      const clusterIconLayout = ymaps.templateLayoutFactory.createClass('' +
        '<div class="infrastructure-map-pin-cluster">' +
        '<span>{{ properties.geoObjects.length }}</span>' +
        '</div>')

      return new ymaps.Clusterer({
        clusterDisableClickZoom: false,
        clusterNumbers: [50],
        clusterIconLayout: clusterIconLayout,
        clusterIconShape: {
          type: 'Rectangle',
          coordinates: [[0, 0], [46, 46]]
        }
      })
    },
    _generatePlacemark: function (point) {
      const iconContentLayout = ymaps.templateLayoutFactory.createClass(
        `<div class="cargo-rate-calculator-map-poins">${point.label}</div>`
      );

      return  new ymaps.Placemark(
        point.coordinates,
        {clusterName: "clusterName"},
        {
          iconLayout: "default#imageWithContent",
          iconImageHref: '',
          content: "",
          contentLayout: "",
          iconContentLayout: iconContentLayout
        })
    },
  }
}
